@if (heading) {
  <h2 >{{ heading }}</h2>
}

<div class="description-container">
  @for (item of items; track $index) {
    <payments-description-list-item [label]="item.label" [value]="item.value"> </payments-description-list-item>
  }

  <!-- In case the value is not simple plain text value then use projection instead -->
  <ng-content></ng-content>
</div>
